<script setup></script>
<template>
  <h1 class="text-5xl">Welcome to 8 Puzzle Challenge</h1>
</template>
